// ROUTES
import { ROUTE_IIRGD } from 'routes/paths';

export const ROUTE_IIRGD_CIN_EMITIR = `${ROUTE_IIRGD}/cin/pesquisar`;
